var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        title: "Thêm học sinh vào nhóm",
        visible: _vm.dialogVisible,
        size: "lg",
        "use-panel": false,
        "confirm-text": "Lưu",
        "confirm-type": "primary",
        "confirm-loading": _vm.loadingButton,
        "cancel-text": "Hủy",
        "cancel-type": "",
        "cancel-icon": "",
        "confirm-icon": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        "before-close": _vm.handleClose,
        cancel: _vm.handleClose,
        confirm: _vm.handleSave,
        open: _vm.handleOpen,
      },
    },
    [
      _c(
        "div",
        { staticClass: "sk-panel" },
        [
          _c("div", { staticClass: "sk-panel-head" }, [
            _c("div", { staticClass: "sk-panel-icon" }, [
              _c("i", { staticClass: "el-icon-s-operation" }),
            ]),
            _c("div", [
              _c("p", { staticClass: "sk-panel-title" }, [
                _vm._v("Quản lý học sinh"),
              ]),
              _c("p", { staticClass: "sk-panel-subtitle" }, [
                _vm._v("Thêm hoặc bỏ học sinh khỏi nhóm"),
              ]),
            ]),
          ]),
          _c("el-transfer", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loadingDataTransfer,
                expression: "loadingDataTransfer",
              },
            ],
            attrs: {
              "element-loading-text": _vm.$tableLoading,
              filterable: "",
              "filter-placeholder": "Nhập thông tin học sinh",
              titles: ["Tất cả học sinh", "Học sinh trong nhóm"],
              "button-texts": ["", ""],
              data: _vm.dataSource,
            },
            model: {
              value: _vm.dataTarget,
              callback: function ($$v) {
                _vm.dataTarget = $$v
              },
              expression: "dataTarget",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }